import { useNavigate } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { ExportsPeriodsModalPageQueryDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import Exports from 'modules/attendance/components/TimeTracking/Modals/Exports'
import { useModule as useTimeoffModule } from 'modules/timeoff/hooks/useModule'

const ExportsPeriodsModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { periodType, year, month, day } = useStrictParams<
    'periodType' | 'year' | 'month' | 'day'
  >()
  const { data: policyData, loading: policyLoading } = useQuery(
    ExportsPeriodsModalPageQueryDocument
  )

  const onClose = () => {
    navigate(
      navigation.timeTracking.list.periodTypeYearMonthDay.fullPath({
        periodType,
        year,
        month,
        day,
      })
    )
  }

  useEffect(() => {
    track(trackingEvents.timeTracking.exportTimeTrackingStart)
  }, [])

  const { loading: loadingTimeoff, enabled: timeoffEnabled } = useTimeoffModule()

  if (loadingTimeoff || policyLoading) return <Loading />

  const canBrazilianExportAccess =
    policyData?.attendance._policies.brazilianExportAccess.can ?? false

  return (
    <Exports
      onClose={onClose}
      timeoffEnabled={timeoffEnabled}
      periodType={periodType}
      canBrazilianExportAccess={canBrazilianExportAccess}
    />
  )
}

export default ExportsPeriodsModalPage
